import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  \n  ", "\n  ", "\n  ", "\n  ", "\n  \n  ", "\n  \n  ", "\n  ", "\n  \n  ", "\n  ", "\n  ", "\n \n  ", "\n  ", "\n  ", "\n  \n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { alignContent, alignItems, alignSelf, flex, flexBasis, flexDirection, flexFlow, flexGrow, flexShrink, flexWrap, justifyContent, justifyItems, justifySelf, order } from '../style';
import { styleForBreakpoints } from '../helpers/media-style';
export var flexMixin = css(_templateObject(), function (_ref) {
  var _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline;
  return styleForBreakpoints(inline, function (inline) {
    return "display: " + (inline ? 'inline-flex' : 'flex') + ";";
  });
}, mixin(flex, 'flex'), mixin(flexBasis, ['flexBasis', 'basis']), mixin(flexFlow, ['flexFlow', 'flow']), mixin(flexGrow, ['flexGrow', 'grow']), mixin(flexShrink, ['flexShrink', 'shrink']), mixin(order, 'order'), mixin(flexDirection, ['flexDirection', 'direction']), mixin(flexWrap, ['flexWrap', 'wrap']), mixin(justifyContent, ['justifyContent', 'justify']), mixin(justifyItems, 'justifyItems'), mixin(justifySelf, 'justifySelf'), mixin(alignItems, ['alignItems', 'align']), mixin(alignContent, 'alignContent'), mixin(alignSelf, 'alignSelf'), function (_ref2) {
  var _ref2$center = _ref2.center,
      center = _ref2$center === void 0 ? false : _ref2$center;
  return styleForBreakpoints(center, function (center) {
    return center ? "\n          justify-content: center !important;\n          align-items: center !important;\n        " : '';
  });
});
export var flexKeys = ['inline', 'center', 'flex', 'direction', 'flexDirection', 'wrap', 'flexWrap', 'justify', 'justifyContent', 'justifyItems', 'justifySelf', 'align', 'alignItems', 'alignContent', 'alignSelf', 'basis', 'flexBasis', 'flow', 'flexFlow', 'grow', 'flexGrow', 'shrink', 'flexShrink', 'order'];